import styled from '@emotion/styled';

export const ChooseMemberSubText = styled.div`
  color: var(--Neutral-Gray-3, #97948d);
  font-family: 'SofiaProSoft';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  display: inline;
`;
